import { Injectable } from '@angular/core';
import { DevstroupeNavigationItem } from '@devstroupe/components/navigation';
import { DevstroupeMockApiService } from '@devstroupe/lib/mock-api';
import {
    compactNavigation,
    futuristicNavigation,
    horizontalNavigation,
    classicNavigation,
    adminNavigation,
    requesterNavigation,
} from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private readonly _compactNavigation: DevstroupeNavigationItem[] = compactNavigation;
    private readonly _classicNavigation: DevstroupeNavigationItem[] = classicNavigation;
    private readonly _futuristicNavigation: DevstroupeNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: DevstroupeNavigationItem[] = horizontalNavigation;
    private readonly _adminNavigation: DevstroupeNavigationItem[] = adminNavigation;
    private readonly _requesterNavigation: DevstroupeNavigationItem[] = requesterNavigation;

    /**
     * Constructor
     */
    constructor(private _devstroupeMockApiService: DevstroupeMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._devstroupeMockApiService.onGet('api/common/navigation').reply(() => {
            // Fill compact navigation children using the default navigation
            this._compactNavigation.forEach((compactNavItem) => {
                this._classicNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === compactNavItem.id) {
                        compactNavItem.children = cloneDeep(defaultNavItem.children);
                    }
                });
            });

            // Fill futuristic navigation children using the default navigation
            this._futuristicNavigation.forEach((futuristicNavItem) => {
                this._classicNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === futuristicNavItem.id) {
                        futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                    }
                });
            });

            // Fill horizontal navigation children using the default navigation
            this._horizontalNavigation.forEach((horizontalNavItem) => {
                this._classicNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                    }
                });
            });

            // Return the response
            return [
                200,
                {
                    compact: cloneDeep(this._compactNavigation),
                    classic: cloneDeep(this._classicNavigation),
                    futuristic: cloneDeep(this._futuristicNavigation),
                    horizontal: cloneDeep(this._horizontalNavigation),
                    admin: cloneDeep(this._adminNavigation),
                    requester: cloneDeep(this._requesterNavigation),
                },
            ];
        });
    }
}
